import {
  FontFamilyToken,
  FontLineHeightToken,
  FontSizeToken,
  FontWeightToken,
  getFontFamilyTokenValue,
  getFontLineHeightTokenValue,
  getFontSizeTokenValue,
  getFontWeightTokenValue
} from "../base/typography";

export type TextToken =
  | "text.heading.page"
  | "text.heading.section"
  | "text.heading.subsection"
  | "text.body.primary"
  | "text.body.secondary"
  | "text.ui.label"
  | "text.ui.table"
  | "text.ui.caption";

export const TEXT_TOKENS: TextToken[] = [
  "text.heading.page",
  "text.heading.section",
  "text.heading.subsection",
  "text.body.primary",
  "text.body.secondary",
  "text.ui.label",
  "text.ui.table",
  "text.ui.caption"
];

type TextTokenDefinition = {
  fontFamily: FontFamilyToken;
  fontSize: FontSizeToken;
  fontWeight: FontWeightToken;
  lineHeight: FontLineHeightToken;
};

const textTokenDefinitions: Record<TextToken, TextTokenDefinition> = {
  "text.heading.page": {
    fontFamily: "font.family.heading",
    fontSize: "font.size.xxl",
    fontWeight: "font.weight.semibold",
    lineHeight: "font.line-height.tight"
  },
  "text.heading.section": {
    fontFamily: "font.family.heading",
    fontSize: "font.size.xl",
    fontWeight: "font.weight.semibold",
    lineHeight: "font.line-height.tight"
  },
  "text.heading.subsection": {
    fontFamily: "font.family.heading",
    fontSize: "font.size.lg",
    fontWeight: "font.weight.medium",
    lineHeight: "font.line-height.tight"
  },
  "text.body.primary": {
    fontFamily: "font.family.base",
    fontSize: "font.size.md",
    fontWeight: "font.weight.regular",
    lineHeight: "font.line-height.normal"
  },
  "text.body.secondary": {
    fontFamily: "font.family.base",
    fontSize: "font.size.sm",
    fontWeight: "font.weight.regular",
    lineHeight: "font.line-height.normal"
  },
  "text.ui.label": {
    fontFamily: "font.family.base",
    fontSize: "font.size.xs",
    fontWeight: "font.weight.medium",
    lineHeight: "font.line-height.normal"
  },
  "text.ui.table": {
    fontFamily: "font.family.base",
    fontSize: "font.size.xs",
    fontWeight: "font.weight.medium",
    lineHeight: "font.line-height.normal"
  },
  "text.ui.caption": {
    fontFamily: "font.family.base",
    fontSize: "font.size.xxs",
    fontWeight: "font.weight.regular",
    lineHeight: "font.line-height.normal"
  }
};

export const getTextTokenDefinition = (token: TextToken): TextTokenDefinition => textTokenDefinitions[token];

export type ResolvedTextToken = {
  fontFamily: string;
  fontSize: string;
  fontWeight: number;
  lineHeight: number;
};

export const resolveTextToken = (token: TextToken): ResolvedTextToken => {
  const definition = textTokenDefinitions[token];
  return {
    fontFamily: getFontFamilyTokenValue(definition.fontFamily),
    fontSize: getFontSizeTokenValue(definition.fontSize),
    fontWeight: getFontWeightTokenValue(definition.fontWeight),
    lineHeight: getFontLineHeightTokenValue(definition.lineHeight)
  };
};
